export const ENV_VARS = {
  // @ts-expect-error Ignore module error
  DEV: import.meta.env.DEV,
  // @ts-expect-error Ignore module error
  PROD: import.meta.env.PROD,
  // @ts-expect-error Ignore module error
  VITE_CLERK_PUBLISHABLE_KEY: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  // @ts-expect-error Ignore module error
  VITE_PROMO_LINK: import.meta.env.VITE_PROMO_LINK,
  // @ts-expect-error Ignore module error
  VITE_GOOGLE_PIXEL_ID: import.meta.env.VITE_GOOGLE_PIXEL_ID,
  // @ts-expect-error Ignore module error
  VITE_HOST_REDIRECT: import.meta.env.VITE_HOST_REDIRECT,
  // @ts-expect-error Ignore module error
  VITE_FACEBOOK_PIXEL_ID: import.meta.env.VITE_FACEBOOK_PIXEL_ID,
  // @ts-expect-error Ignore module error
  VITE_EXPRESS_PORT: import.meta.env.VITE_EXPRESS_PORT,
  // @ts-expect-error Ignore module error
  VITE_RUDDERSTACK_FRONTEND_WRITE_KEY: import.meta.env.VITE_RUDDERSTACK_FRONTEND_WRITE_KEY,
  // @ts-expect-error Ignore module error
  VITE_RUDDERSTACK_DATA_PLANE_URL: import.meta.env.VITE_RUDDERSTACK_DATA_PLANE_URL,
};
